import { render, staticRenderFns } from "./GreyCross.vue?vue&type=template&id=28d2b84c"
import script from "./GreyCross.vue?vue&type=script&lang=js"
export * from "./GreyCross.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports